import Axios from "axios";
import { httpPost } from "../../../../../../Utils/apis/apis";
import { enhanceEvalString } from "../../Renderers/Views/ResultCards/M_ResultCardHelper.js";

export const portfolioapproval = {
  FILTERVALUE: "filterValue",
  TEMPLATEID: "templateId",
  TEMPLATEFILTERID: "templateFilterID",
  CURRENTPATHNAME:"currentPathName"
};
export function regexMatchAndReplaceFromDocument(inputText, regexPattern) {
  let placeholderMatches = inputText.matchAll(regexPattern);
  let currentValue = placeholderMatches.next();
  while (!currentValue.done) {
    let [placeholder, placeholderId] = currentValue;
    let customHtml =
      placeholderId &&
      document.getElementById(placeholderId) &&
      document.getElementById(placeholderId).innerHTML
        ? document.getElementById(placeholderId).innerHTML
        : "";
    if (customHtml) {
      inputText = inputText.replace(placeholder, customHtml);
    }
    currentValue = placeholderMatches.next();
  }
  return inputText;
}


export const saveBlobAsFile = (blobData, fileName) => {
  const objectUrl = window.URL.createObjectURL(new Blob([blobData]));
  const link = document.createElement("a");
  link.href = objectUrl;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
};


export const downloadConfiguredFile = async (fileConfig = {}, defaultFileName) => {
  const response = await Axios({
    url: fileConfig.url,
    method: "GET",
    responseType: "blob",
  });
  saveBlobAsFile(response.data, fileConfig.fileName || defaultFileName);
};


export const triggerCallApi = async (callDetails = {}, crmId) => {
  return await httpPost(
    enhanceEvalString(callDetails.url || "", { crmId }),
    callDetails.payload ? { ...callDetails.payload } : {}
  );
};


export const downloadPptApi = async (pptId, payload) => {
  return await httpPost(
    `${process.env.PPT_DOWNLOAD_URL}/PPT/download/${pptId}`,
    payload,
    { responseType: "blob" }
  );
};


export const fetchPdfReportApi = async (reportId, payload, options = {}) => {
  return await httpPost(
    `${process.env.PDF_DOWNLOAD_URL}PDF/download/${reportId}`,
    payload,
    options
  );
};


export const generatePdfFromHtmlApi = async (payload) => {
  return await httpPost(`${process.env.MINERVA_CHART_PDF}pdf?`, payload, {
    responseType: "blob",
  });
};


export const downloadExcelTemplateApi = async (payload) => {
  return await httpPost(
    `${process.env.PortalAdminAPIUrl}/api/ExcelTemplates/GetExcelTemplate`,
    payload,
    {
      responseType: "blob",
      headers: {
        "x-functions-key": process.env.EXCEL_UPLOAD_API_KEY,
      },
    }
  );
};
